import React from "react";
import Page from "../../Components/Page/Page";
import ibp_Fraunhofer from "./ibp_Fraunhofer.gif";
import ProPolisLogo from "./ProPolisLogo.png";
import BMBF_en from "../Projects/BMBF_en.jpg";
import BMBF_de from "../Projects/BMBF_de.jpg";
import Fona_en from "./Fona_en.png";
import Fona_de from "./Fona_de.png";
import DLR from "./DLR.jfif";
import { withRouter } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import "./About.scss";

const GNU_LICENSE_LINK =
  "https://www.gnu.org/licenses/agpl-3.0.html.en#license-text";
const GNU_ALT_LINK = "https://www.gnu.org/licenses/#AGPL";
const GITLAB_REPOSITORY_LINK =
  "https://gitlab.cc-asp.fraunhofer.de/palm_gui/palm4u_gui";
const PRO_POLIS_LINK = "https://propolis.azurewebsites.net/";

export const LinkText = (props) => {
  return (
    <a
      href={props.to || "#"}
      target="_blank"
      rel="noopener noreferrer"
      title={props.title || ""}
      style={{ color: "rgb(0, 102, 204)" }}
    >
      {props.children}
    </a>
  );
};

const About = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <h1 className="settings-hdr">{t("About")}</h1>
      <div className="about-info" style={{ marginBottom: "16px" }}>
        <Trans
          i18nKey="AboutDevelopment"
          components={{
            link1: <LinkText to={GNU_LICENSE_LINK} title="My link1" />,
            link2: (
              <LinkText to={GITLAB_REPOSITORY_LINK} title="Another link" />
            ),
          }}
        />
      </div>
      <div className="about-info">
        <Trans
          i18nKey="AboutInformation"
          components={{
            link1: <LinkText to={GNU_ALT_LINK} title="My link2" />,
            br: <br />,
          }}
        />
      </div>
      <div className="sponsor-img-section sponsor-img-section-gap">
        <img src={ibp_Fraunhofer} height={50} alt={"ibp_img"} />
      </div>
      <h3 className="about-info">{t("Acknowledgement")}</h3>
      <div className="about-info">{t(`AboutMinistry`)}</div>
    </Page>
  );
};

export default withRouter(About);
